import React, { FC, useEffect } from "react";
import { Flex } from "reflexbox";

import { Form } from "@components/Form";
import { FormInput as Input } from "@components/Form/Input";
import { Button, TextButton } from "@icr/react.uicomponents";
import { ReactComponent as IconArrowLeftBlue } from "../../../../assets/icons/arrow-left-blue.svg";
import { useSwal } from "@hooks/useSwal";

import { TModalPassword } from "./types";
import { WebServicePasswordSchema } from "./schema";
import { changePasswordWebservice } from "../ducks";
import { useFormatMessage } from "@hooks/formatMessage";

const WebServicesModalPassword: FC<TModalPassword> = ({ closeModal, initialData }) => {
  const { swalConfirmationMessage, swalAlertWithCallback } = useSwal();
  // Language
  const formatMessage = useFormatMessage();

  useEffect(() => {
    document.body.classList.remove("backdrop");
  }, []);

  const showSuccessMessage = (message: string) => {
    swalAlertWithCallback(
      {
        text: `Password has been ${message}!`,
        type: "success",
        confirmationText: "Ok!",
      },
      closeModal
    );
  };

  const onSubmit = formData => {
    swalConfirmationMessage({
      text: "Do you really want to change this webservice password?",
      type: "info",
      cancelationText: "Cancel",
      confirmationText: "Change password",
    }).then(value => {
      if (value) {
        const { id, password } = formData;

        changePasswordWebservice(id, password).then(res => {
          if (res.success) showSuccessMessage("changed");
        });
      }
    });
  };

  return (
    <div className="modal">
      <div className="modal-header">
        <div className="modal-header-left">
          <TextButton id="backBtn" onClick={closeModal}>
            <Flex justifyContent="center">
              <Flex mr="10px" width="16px" height="16px" alignItems="center">
                <IconArrowLeftBlue />
              </Flex>
              {formatMessage("app.backToOverview")}
            </Flex>
          </TextButton>
        </div>
      </div>
      <Flex flexDirection="column">
        <Form onSubmit={onSubmit} schema={WebServicePasswordSchema} defaultValues={initialData}>
          <Flex>
            <Input id="id" name="id" hidden />
            <Input
              id="password"
              name="password"
              type="password"
              width="50%"
              label={formatMessage("app.password")}
            />
          </Flex>
          <Flex mt="30px">
            <Input
              id="repeatPassword"
              name="repeatPassword"
              type="password"
              width="50%"
              label={formatMessage("app.repeatPassword")}
            />
          </Flex>
          <Flex justifyContent="flex-end" mt="30px" width="50%">
            <Button id="ModalBtn_cancel" mr="10px" onClick={closeModal} type="button">
              {formatMessage("app.cancel", "Cancel")}
            </Button>
            <Button id="ModalBtn_save" type="submit">
              {formatMessage("app.save", "Save")}
            </Button>
          </Flex>
        </Form>
      </Flex>
    </div>
  );
};

export default WebServicesModalPassword;
